import React, { useState, useEffect, useContext } from 'react';
import { Card, Stack, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import { getTargetPeriods, getTargetFacets } from '../../targets/data';
import OwnershipTargetFacetMetrics from './OwnershipTargetFacetMetrics';
import { ROLES } from '../../auth/role.js'
import RoleContext from '../../auth/RoleContext.js'

const OwnershipTargetsSection = ({
  ownership = undefined,
}) => {
  const roleDetails = useContext(RoleContext)
  const [selectedPeriodId, setSelectedPeriodId] = useState('');
  const [periods, setPeriods] = useState([]);
  const [facets, setFacets] = useState([]);

  const loadPeriods = async () => {
    const periodsData = await getTargetPeriods();
    if (periodsData.status === 'success') {
      const sorted = periodsData.results.sort((a,b) => b.name.localeCompare(a.name))
      if (sorted.length) {
        setSelectedPeriodId(sorted[0].id)
      } else {
        setSelectedPeriodId('')
      }
    }
    setPeriods(periodsData.results ?? [])
  }

  const isActive = () => {
    return ((o) => !(/^(false|0)$/i).test(o?.isActive) && !!(o?.isActive))(ownership)
  }

  const editingEnabled = (isActive() && roleDetails.hasRole([
      ROLES.BOTTLER_CORP,
      ROLES.QSE_MGR,
      ROLES.SUPPLY_CHAIN_MGR,
      ROLES.MFI_ADMIN,
      ROLES.ADMIN
    ]))

  const loadActiveFacets = async () => {
    const d = await getTargetFacets({ active: true })
    const results = (d.results ?? []).sort((a,b) => a.name.localeCompare(b.name))
    setFacets(results)
  }


  useEffect(() => {
    // Load available target periods when component renders
    loadPeriods()
    loadActiveFacets()
  }, [])

  return (
    <Card sx={{ padding: 2, mb: 1 }} variant='elevation' elevation='0' square>
      <Stack spacing={2}>
        {periods && <Stack direction='row' columnGap={1} alignItems={'center'}>
          <Typography variant='body'>Period:</Typography>
          <Select
            size='small'
            value={selectedPeriodId}
            onChange={(e) => setSelectedPeriodId(e.target.value)}
            autoWidth
          >
            {periods.sort((a,b) => b.name.localeCompare(a.name)).map((period) => (
              <MenuItem key={period.id} value={period.id} sx={{fontStyle: period.active ? 'normal' : 'italic'}}>
                {period.name}
              </MenuItem>
            ))}
          </Select>
        </Stack>}

        {selectedPeriodId && selectedPeriodId !== '' && facets.length > 0 && (
          <Stack spacing={1}>
            {facets.map((facet) => (
              <OwnershipTargetFacetMetrics
                key={facet.id}
                ownership={ownership}
                targetFacet={facet}
                targetPeriod={periods.find(p => p.id === selectedPeriodId)}
                editable={editingEnabled}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default OwnershipTargetsSection;